module.exports = __webpack_public_path__ + "img/round2-research.be1d4c60.jpg";